import { render, staticRenderFns } from "./useCarApplicationFormTab.vue?vue&type=template&id=068b0e28&scoped=true&"
import script from "./useCarApplicationFormTab.vue?vue&type=script&lang=js&"
export * from "./useCarApplicationFormTab.vue?vue&type=script&lang=js&"
import style0 from "./useCarApplicationFormTab.vue?vue&type=style&index=0&id=068b0e28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068b0e28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('068b0e28')) {
      api.createRecord('068b0e28', component.options)
    } else {
      api.reload('068b0e28', component.options)
    }
    module.hot.accept("./useCarApplicationFormTab.vue?vue&type=template&id=068b0e28&scoped=true&", function () {
      api.rerender('068b0e28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/CarForm/useCarApplicationFormTab.vue"
export default component.exports